import { KeyboardArrowUpOutlined } from '@mui/icons-material';
import { Fab, Zoom } from '@mui/material';
import { useEffect, useState } from 'react';

interface BackToTopProps {
  containerId?: string;
}

export const BackToTop = ({ containerId }: BackToTopProps) => {
  const [showBackToTop, setShowBackToTop] = useState(false);

  useEffect(() => {
    const scrollContainer = containerId
      ? document.getElementById(containerId)
      : window;
    if (!scrollContainer) return;

    const handleScroll = () => {
      const scrollTop =
        'scrollTop' in scrollContainer
          ? scrollContainer.scrollTop
          : (scrollContainer as Window).scrollY;

      setShowBackToTop(scrollTop > 200);
    };

    scrollContainer.addEventListener('scroll', handleScroll);

    return () => {
      scrollContainer.removeEventListener('scroll', handleScroll);
    };
  }, [containerId]);

  return (
    <Zoom in={showBackToTop}>
      <Fab
        color="primary"
        size="small"
        onClick={() => {
          const scrollContainer = document.getElementById('right_side_page');
          if (scrollContainer) {
            scrollContainer.scrollTo({ top: 0, behavior: 'smooth' });
          }
        }}
        sx={{
          position: 'fixed',
          bottom: '42px',
          right: '42px',
          zIndex: 1000,
        }}
        aria-label="Back to top"
      >
        <KeyboardArrowUpOutlined />
      </Fab>
    </Zoom>
  );
};
